import { NavigateFunction } from 'react-router-dom';
import {
    getAccountPagePath,
    getAccountsPagePath,
    getClientPagePath,
    getClientsPagePath,
    getOrderRequestPagePath,
    getOrderRequestsPagePath,
    getOrderSalePagePath,
    getOrderSalesPagePath,
} from './get-route-path';

export function navigateToAccountPage({
    navigate,
    accountId,
    replace = false,
}: Parameters<typeof getAccountPagePath>[0] & {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(
        getAccountPagePath({
            accountId,
        }),
        {
            replace,
        },
    );
}

export function navigateToAccountsPage({
    navigate,
    replace = false,
}: {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(getAccountsPagePath(), {
        replace,
    });
}

export function navigateToClientsPage({
    navigate,
    replace = false,
}: {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(getClientsPagePath(), {
        replace,
    });
}

export function navigateToClientPage({
    navigate,
    accountId,
    replace = false,
}: Parameters<typeof getClientPagePath>[0] & {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(
        getClientPagePath({
            accountId,
        }),
        {
            replace,
        },
    );
}

export function navigateToOrderRequestPage({
    navigate,
    orderRequestId,
    replace = false,
}: Parameters<typeof getOrderRequestPagePath>[0] & {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(
        getOrderRequestPagePath({
            orderRequestId,
        }),
        {
            replace,
        },
    );
}

export function navigateToOrderRequestsPage({
    navigate,
    replace = false,
}: {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(getOrderRequestsPagePath(), {
        replace,
    });
}

export function navigateToOrderSalePage({
    navigate,
    orderSaleId,
    replace = false,
}: Parameters<typeof getOrderSalePagePath>[0] & {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(
        getOrderSalePagePath({
            orderSaleId,
        }),
        {
            replace,
        },
    );
}

export function navigateToOrderSalesPage({
    navigate,
    replace = false,
}: {
    navigate: NavigateFunction;
    replace?: boolean;
}) {
    navigate(getOrderSalesPagePath(), {
        replace,
    });
}
